<template>
    <div name="check-box">
        <img class="check-image" v-if="checked" src="../../assets/checked.png" @click="onClick" />
        <img class="check-image" v-else src="../../assets/unchecked.png" @click="onClick"/>
    </div>
</template>

<script>
export default {
    name: 'checkBox',
    props: ['checked'],
    methods: {
        onClick: function()
        {
            this.$emit('onClick')
        }
    }

}
</script>

<style scoped>
    .check-image {
        width: 20px;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/atoms/CheckBox.vue